var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcInboxBlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M15.5 3.7a6.296 6.296 0 0 1 6.293 5.997L21.8 10v2.5a5.779 5.779 0 0 1-1.617 4.017 5.777 5.777 0 0 1-3.603 1.753l-.087.006-.197 1.934a.8.8 0 0 1-1.209.604l-.09-.063-3.039-2.451H8.5a6.286 6.286 0 0 1-4.245-1.644l-.212-.201a6.317 6.317 0 0 1-1.836-4.152L2.2 12v-2c0-1.692.672-3.28 1.845-4.456a6.305 6.305 0 0 1 4.152-1.837L8.5 3.7zm0 1.6H8.52l-.263.006a4.685 4.685 0 0 0-3.08 1.37A4.679 4.679 0 0 0 3.8 10v1.98l.006.262A4.694 4.694 0 0 0 8.5 16.7h3.74c.183 0 .36.063.502.177l2.112 1.703.12-1.167a.8.8 0 0 1 .709-.713l.102-.005.244.005a4.177 4.177 0 0 0 3-1.292A4.175 4.175 0 0 0 20.2 12.5v-2.48l-.006-.262A4.694 4.694 0 0 0 15.5 5.3zm-3.5.95a4.75 4.75 0 1 1 0 9.5 4.75 4.75 0 0 1 0-9.5zm2.667 2.893-4.524 4.524a3.25 3.25 0 0 0 4.524-4.524zM12 7.75a3.25 3.25 0 0 0-2.859 4.798l4.407-4.407A3.233 3.233 0 0 0 12 7.75z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24-10h268v44H-24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#BDBDBD",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInboxBlock);
export default __webpack_public_path__ + "static/media/ic-inbox-block.1547e451d92e51f6cf15e957996aae32.svg";
export { ForwardRef as ReactComponent };